import BotonDirecto from "./BotonDirecto.vue";
import BotonDirectoProperties from "./BotonDirectoProperties.vue";

const BotonDirectoPlugin = {
  install(Vue) {
    Vue.component("BotonDirecto", BotonDirecto);
    Vue.component("BotonDirectoProperties", BotonDirectoProperties);
  },
};

export default BotonDirectoPlugin;
